import { render } from "./pictures.vue?vue&type=template&id=56ddf5b9"
import script from "./pictures.vue?vue&type=script&lang=js"
export * from "./pictures.vue?vue&type=script&lang=js"

import "./pictures.vue?vue&type=style&index=0&id=56ddf5b9&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/pictures.vue'],['render',render],['__file',"pictures.vue"]])

export default __exports__